import { ISelfAssessmentProps } from "../types/interfaces/ISelfAssessmentProps";
import Competencies from "./Competencies";
import SelfAssessmentStaticText from "./SelfAssessmentStaticText";
import { Divider} from "@mui/material";

//This component is responsible for rendering the self-assessment view. 
const SelfAssessment: React.FC<ISelfAssessmentProps> = ({ competencies, onRatingChange }) =>  {
    return (
        <>
            <SelfAssessmentStaticText />
            {competencies && competencies.length > 0 && <Competencies competencies={competencies} onRatingChange={onRatingChange} />}
            <Divider sx={{mt:1, mb:5}}></Divider>
        </>
    );
}

export default SelfAssessment;